"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@main/constants");
var session_enum_1 = __importDefault(require("@main/enums/session-enum"));
require("array-from-polyfill");
require("polyfill-array-includes");
require("promise-polyfill/src/polyfill");
var sessionstorage_1 = __importDefault(require("sessionstorage"));
var toastr_1 = __importDefault(require("toastr"));
var common_1 = __importDefault(require("./web/common"));
var web_agent_1 = __importDefault(require("./web/web-agent"));
var PageScript = /** @class */ (function () {
    function PageScript() {
        this._forms = [];
        common_1.default.disableBackNavigator();
        toastr_1.default.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: 'toast-bottom-left',
            preventDuplicates: false,
            onclick: null,
            showDuration: '10000',
            hideDuration: '1000',
            timeOut: '5000',
            extendedTimeOut: '1000',
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut',
        };
        this.onMount();
        var subscrided = this.subscribe();
        for (var _i = 0, subscrided_1 = subscrided; _i < subscrided_1.length; _i++) {
            var component = subscrided_1[_i];
            component.element.on(component.event, component.handler);
        }
        if (this._forms.length !== 0) {
            this.registerForms();
        }
        return this;
    }
    PageScript.prototype.getContext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web_agent_1.default().post(constants_1.CONTEXT_URI)];
                    case 1:
                        data = (_a.sent()).data;
                        sessionstorage_1.default.setItem(session_enum_1.default.CONTEXT, JSON.stringify(data));
                        return [2 /*return*/];
                }
            });
        });
    };
    PageScript.prototype.registerForms = function () {
        common_1.default.registerForms(this._forms);
    };
    return PageScript;
}());
exports.default = PageScript;
